<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      cell-class-name="align-top"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:imageUrl="{ row }">
        <el-image
          class="viewImage"
          :preview-src-list="[row.defaultImageUrl]"
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
        />
      </template>
      <template v-slot:status="{ row }">
        <div>
          <el-tag
            size="mini"
            :type="
              row.greyFabricStatus === 'Y'
                ? 'success'
                : row.greyFabricStatus === 'D'
                ? 'danger'
                : 'primary'
            "
          >
            {{ row.v_greyFabricStatus }}
          </el-tag>
        </div>
      </template>
      <template v-slot:greyFabricName="{ row }">
        <div>
          <span>{{ row.greyFabricName }}</span>
          <br />
          <span>{{ row.greyFabricNameEn }}</span>
          <br />
          <span>NO：{{ row.greyFabricNo }}</span>
        </div>
      </template>
      <template v-slot:greyFabricWeight="{ row }">
        <div>
          <span
            >{{ $l('table_label_key_color') || '颜色' }}：{{
              row.greyFabricColor
            }}</span
          >
          <br />
          <span
            >{{ $l('table_label_key_weight') || '克重' }}：{{
              row.greyFabricWeight
            }}
            {{ row.greyFabricWeightUnit }}
          </span>
          <br />
          <span
            >{{ $l('table_label_key_Yarn_Count') || '支数' }}：{{
              row.greyYarnCount
            }}</span
          >
        </div>
      </template>
      <template v-slot:greyFabricContent="{ row }">
        <div>
          <span>{{ row.greyFabricContent }}</span>
          <br />
          <span>{{ row.greyFabricContentEn }}</span>
        </div>
      </template>
      <template v-slot:customerUse="{ row }">
        <span>{{ row.v_isCustomerUse }}</span>
        <br />
        <span>{{ row.custName }}</span>
      </template>
      <template v-slot:purchaseUnit="{ row }">
        <div>
          <span>{{ row.purchaseUnitPrice }} / {{ row.v_purchaseUnit }}</span>
        </div>
      </template>
      <template v-slot:createBy="{ row }">
        <div>
          <span>{{ row.createByName }}</span>
          <br />
          <span>{{ row.createDate }}</span>
        </div>
      </template>
      <template v-slot:modifyBy="{ row }">
        <div>
          <span>{{ row.modifyByName }}</span>
          <br />
          <span>{{ row.modifyDate }}</span>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                v-show="opt.show == undefined ? true : opt.show(row)"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import tableOpts from './table-opts'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      if (!menuType) return

      switch (menuType) {
        case 'detail':
        case 'edit':
          this.openEditPage({
            pageType: menuType,
            greyFabricCode: data.greyFabricCode,
          })
          break
        case 'delete':
          this.del(data)
          break
        default:
          console.error('menuType configuration error: ', menuType)
      }
    },
    openEditPage({ pageType, greyFabricCode }) {
      this.$emit('openEditPage', {
        pageType,
        greyFabricCode,
      })
    },
    del({ greyFabricCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .masterGreyFabricDelApi({ greyFabricCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          })
      })
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .vxe-cell {
    max-height: 100% !important;
  }
  .vxe-body--column {
    padding: 7px 0 9px 0 !important;
  }
}
.text {
  color: #6c6c6c;
  font-size: 14px;
}
.viewImage {
  width: 66px;
  height: 66px;
}
</style>
